import useCustomLocation from '@client/app/research/use-custom-location.tsx';
import { createContext } from 'react';

// eslint-disable-next-line react-refresh/only-export-components
export const CustomLocationContext = createContext<string | null>(null);
export default function CustomLocationProvider(props: { children?: React.ReactNode }) {
  const currentPath = useCustomLocation();
  return <CustomLocationContext.Provider value={currentPath}>{props.children}</CustomLocationContext.Provider>;
}
